import { render, staticRenderFns } from "./Newspage.vue?vue&type=template&id=382b0239&"
import script from "./Newspage.vue?vue&type=script&lang=js&"
export * from "./Newspage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports